export {
  startSimulatorVideoCapture,
  stopSimulatorVideoCapture,
  type AxeHelpers,
  type StartVideoCaptureResult,
  type StopVideoCaptureResult,
} from '../video_capture.ts';
